import Cookies from 'universal-cookie';

// Reads the sticky campaign utm_source cookie so it survives shopping session recreation.

// Cross repo contract with jeefour-home, which writes this cookie. A mismatch fails silently.
export const STICKY_UTM_COOKIE = 'utm_source';

const getCookies = () =>
  new Cookies(typeof document !== 'undefined' ? document.cookie : null);

// Removes the sticky utm_source cookie.
export const clearStickyUtmSource = () => {
  if (typeof document === 'undefined') {
    return;
  }

  try {
    getCookies().remove(STICKY_UTM_COOKIE, { path: '/' });
  } catch (e) {
    // no-op
  }
};

// Returns the persisted utm_source when the cookie is ours and unexpired
export const readStickyUtmSource = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  let stored;

  try {
    stored = getCookies().get(STICKY_UTM_COOKIE);
  } catch (e) {
    return null;
  }

  if (!stored) {
    return null;
  }

  // universal-cookie auto parses JSON, but fall back in case it returns a raw string.
  let parsed = stored;

  if (typeof stored === 'string') {
    try {
      parsed = JSON.parse(stored);
    } catch (e) {
      // Not our format, so leave any third party utm_source cookie alone
      return null;
    }
  }

  const { utmSource, expiresAt } = parsed || {};

  if (!utmSource || !expiresAt) {
    return null;
  }

  if (Date.now() >= expiresAt) {
    clearStickyUtmSource();
    return null;
  }

  return utmSource;
};